export default __webpack_public_path__ + "assets/images/58eeb13eee907191d399b93dac332cba-approved_icon_thin.svg";